import { Swiper } from 'vue-awesome-swiper';
import Service from '../org-service';
import { mapGetters } from 'vuex';
import ProductService from '../../service/service-service';
export default {
  components: {
  },
  data() {
    return {
      detail: {},
      sdetail: {},
      slides: [],
      showPhone: true,
      isPhoneVisible: false,
      feifangList: [],
      tuoguanList: [],
      nongjiList: []
    };
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo'
    ])
  },

  watch: {
    slides(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.galleryThumbsLunbo();
          this.galleryTopLunbo();
        });
      }
    }
  },

  created() {
    this.getPartnerDetail();
    this.getAllServiceList();
  },
  methods: {
    getPartnerDetail() {
      Service.getPartnerDetail({ id: this.$route.query.id, type: 'arongqi' }).then(res => {
        this.detail = res;
        this.slides = res.coverImg;
        // console.log(this.$route.query.sid,'sid');
        // console.log(this.$route.query.id,'id');
      });
      Service.getPartnerDetail1({ id: this.$route.query.sid }).then(res => {
        this.sdetail = res;
        console.log(this.sdetail, '2313213');
      });
    },

    getAllServiceList() {
      ProductService.getServiceProductList({
        tId: '66aaf784247b9fffdb5eba0b',
        limit: 'unlimited',
        partnerId: this.$route.query.id
      }).then(res => {
        this.tuoguanList = res.result;
      });
      ProductService.getServiceList({ tId: '66aaf784247b9fffdb5eba0b', limit: 'unlimited' }).then(res => {
        this.feifangList = res.filter(item => item.category.indexOf('002') === 0);
        this.nongjiList = res.filter(item => item.category.indexOf('003') === 0);
      });
    },

    toTuoguanDetail(item) {
      this.$router.push('/socialized-service/service/detail?id=' + item._id + '&partnerId=' + item.partnerId);
    },

    toOtherDetail(item) {
      this.$router.push('/socialized-service/partner/partner-detail?id=' + this.$route.query.id + '&type=' + item.category);
    },

    // 联动轮播
    galleryThumbsLunbo() {
      if (this.galleryThumbs) {
        this.galleryThumbs.destory();
      }
      this.galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 15,    // 在slide之间设置距离（单位px）
        slidesPerView: 5,    // 设置slider容器能够同时显示的slides数量
        loop: false,        // 设置为true 则开启loop模式
        freeMode: true,    // 默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 5,    // 一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true,   // 开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true   // 开启这个参数来计算每个slide的progress(进度、进程)
      });
    },
    galleryTopLunbo() {
      if (this.galleryTop) {
        this.galleryTop.destory();
      }
      setTimeout(() => {
        this.galleryTop = new Swiper('.gallery-top', {
          autoplay: {
            delay: 1000
          },
          spaceBetween: 10,
          loop: false,
          loopedSlides: 5,
          // 左右按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          thumbs: {        // thumbs组件专门用于制作带缩略图的swiper
            swiper: this.galleryThumbs
          }
        });
      }, 100);
    },
    changeActiveIndex(index) {
      console.log(index);
      this.$refs.carousel.slideTo(index);
      this.$refs.carousel.update();
    },
    updateCarousel() {
      this.$refs.carousel.update();
    },
    toApplyPage() {
      if (!this.isSignin) {
        this.$router.push('/signin');
        return;
      }
      this.$router.push('/socialized-service/service/apply?partnerId=' + this.$route.query.id + '&type=' + this.$route.query.type);
    },
    goBack() {
      this.$router.go(-2);
    },
    togglePhoneDisplay() {
      this.isPhoneVisible = !this.isPhoneVisible;
      this.showPhone = !this.showPhone;
    }
  }
};
